import React, { useMemo, useState, useEffect } from "react";
import { Popup, Input } from "semantic-ui-react";
import { isEmpty } from "lodash";
import { useAsyncDebounce } from "react-table";

export const GlobalFilter = ({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter
}) => {
  const count = preGlobalFilteredRows.length;
  const [value, setValue] = useState(globalFilter);

  useEffect(()=>{
    setValue(globalFilter)
  }, [globalFilter]);

  const onGlobalFilterChange = useAsyncDebounce(value => {
    setGlobalFilter(value || undefined);
  }, 200);

  const handleGlobalFilterChange = (e, { value }) => {
    setValue(value);
    onGlobalFilterChange(value);
  };

  return (
    <Input
      className="global-filter"
      style={{ marginBottom: 0 }}
      size="mini"
      label="Search"
      icon="filter"
      placeholder={`Search ${count} records...`}
      value={value || ""}
      onChange={handleGlobalFilterChange}
    />
  );
};

export const DefaultColumnFilter = ({
  column: { filterValue, preFilteredRows, setFilter }
}) => {
  const count = preFilteredRows.length;

  return (
    <Input
      value={filterValue || ""}
      className="column-filter"
      size="mini"
      icon="filter"
      onChange={e => {
        setFilter(e.target.value || undefined);
      }}
      placeholder={`Search ${count} records...`}
    />
  );
};

export const BooleanColumnFilter = ({
  column: { filterValue, setFilter, preFilteredRows }
}, enableText="", disableText="") => {
  const options = [
    {
      key: "All",
      text: "All",
      value: ""
    },
    {
      key: "enabled",
      text: `${!isEmpty(enableText)? enableText: "Enabled"}`,
      value: "true"
    },
    {
      key: "disabled",
      text: `${!isEmpty(disableText)? disableText: "Disabled"}`,
      value: "false"
    }
  ];
  return (
    <select
      value={filterValue || "All"}
      onChange={e => {
        setFilter(e.target.value || undefined);
      }}
    >
      {options.map((option, i) => (
        <option key={option.key} value={option.value}>
          {option.text}
        </option>
      ))}
    </select>
  );
};

export const BooleanFilterType = (rows, id, filterValue) => {
  return rows.filter(row => {
    const rowValue = row.values[id];
    if ((rowValue === null || rowValue === undefined) && filterValue === "false")
      return (rowValue === null || rowValue === undefined);
    return String(rowValue) === filterValue;
  });
};

export const StringBooleanFilterType = (rows, id, filterValue) => {
  return rows.filter(row => {
    const rowValue = row.values[id];
    if(isEmpty(rowValue) && filterValue === "false")
      return isEmpty(rowValue);
    else
      return !isEmpty(rowValue) && filterValue === "true";
  });
};

export const SelectColumnFilter = ({
  column: { filterValue, setFilter, preFilteredRows }
}, optionsList = []) => {
  const options = [
    {
      key: "All",
      text: "All",
      value: ""
    },
    ...optionsList.map(option => ({
      key: option,
      text: option,
      value: option
    }))
  ];
  
  return (
    <select
      value={filterValue || "All"}
      onChange={e => {
        setFilter(e.target.value || undefined);
      }}
    >
      {options.map((option, i) => (
        <option key={option.key} value={option.value}>
          {option.text}
        </option>
      ))}
    </select>
  );
};

export const SelectFilterType = (rows, id, filterValue) => {
  return rows.filter(row => {
    const rowValue = row.values[id];
    return rowValue === filterValue;
  });
};

export const SliderColumnFilter = ({
  column: { filterValue, setFilter, preFilteredRows, id },
}) => {
  const [min, max] = useMemo(() => {
    let min = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
    let max = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
    preFilteredRows.forEach(row => {
      min = Math.min(row.values[id], min)
      max = Math.max(row.values[id], max)
    })
    return [min, max]
  }, [id, preFilteredRows])

  return (
    <Popup
      size='mini'
      inverted
      content={`>=${filterValue || min}`}
      trigger={
        <input
          type="range"
          className="slider-filter-input"
          min={min}
          max={max}
          value={filterValue || min}
          onChange={e => {
            setFilter(parseInt(e.target.value, 10))
          }}
        />
      }
    />
  )
};
